var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_927_901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_927_901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5401 34.958L23.5969 24.167C22.8291 24.861 21.9335 25.4093 20.9102 25.812C19.8862 26.2153 18.8113 26.417 17.6854 26.417C14.8956 26.417 12.5409 25.3753 10.6214 23.292C8.70193 21.2087 7.74219 18.6807 7.74219 15.708C7.74219 12.736 8.70193 10.2013 10.6214 8.10401C12.5409 6.00667 14.8827 4.95801 17.6467 4.95801C20.385 4.95801 22.7139 6.00667 24.6334 8.10401C26.5529 10.2013 27.5126 12.736 27.5126 15.708C27.5126 16.9027 27.3336 18.0487 26.9755 19.146C26.6174 20.2433 26.0928 21.264 25.4018 22.208L35.3828 32.958L33.5401 34.958ZM17.6467 23.625C19.6688 23.625 21.3899 22.854 22.81 21.312C24.2307 19.7707 24.9411 17.9027 24.9411 15.708C24.9411 13.514 24.2307 11.639 22.81 10.083C21.3899 8.52767 19.6688 7.75001 17.6467 7.75001C15.5995 7.75001 13.8655 8.52767 12.4448 10.083C11.0247 11.639 10.3146 13.514 10.3146 15.708C10.3146 17.9027 11.0247 19.7707 12.4448 21.312C13.8655 22.854 15.5995 23.625 17.6467 23.625Z",
    fill: "#2B74E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.a95d27adfb2205f27f90b227ec7d467d.svg";
export { ForwardRef as ReactComponent };